import React from 'react';
import { ROICalculator } from './pages/ROICalculator';
export function App() {
  return <ROICalculator data-id="element-0" data-mp="35ckao89f74ji" />;
}